import { render } from "./OpenRegistration.vue?vue&type=template&id=70e8cde6&scoped=true&ts=true"
import script from "./OpenRegistration.vue?vue&type=script&lang=ts"
export * from "./OpenRegistration.vue?vue&type=script&lang=ts"

import "./OpenRegistration.vue?vue&type=style&index=0&id=70e8cde6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e8cde6"]])

export default __exports__